import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { parseDateValue } from '../utils/selectDateHelpers';

export const useSelectDate = ({ name, value, onChange, disabled, isRange }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(moment().startOf('month'));
  const containerRef = useRef(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    if (value) {
      setInputValue(value);
      const parsed = parseDateValue(value, isRange);
      if (parsed.startDate) setStartDate(parsed.startDate);
      if (parsed.endDate) setEndDate(parsed.endDate);
      if (parsed.currentDate) setCurrentDate(parsed.currentDate);
    }
  }, [value, isRange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsFocused(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setInputValue(val);

    if (!val.includes('_')) {
      if (onChange) {
        onChange({ target: { name, value: val } });
      }
    }
  };

  const handleDayClick = (dayMoment) => {
    if (isRange) {
      if (!startDate || (startDate && endDate)) {
        setStartDate(dayMoment);
        setEndDate(null);
        setInputValue(`${dayMoment.format('DD/MM/YYYY')} - __/__/____`);
      } else if (dayMoment.isBefore(startDate)) {
        setStartDate(dayMoment);
      } else {
        setEndDate(dayMoment);
        const rangeVal = `${startDate.format('DD/MM/YYYY')} - ${dayMoment.format('DD/MM/YYYY')}`;
        setInputValue(rangeVal);
        setIsOpen(false);
        if (onChange) onChange({ target: { name, value: rangeVal } });
      }
    } else {
      setStartDate(dayMoment);
      const singleVal = dayMoment.format('DD/MM/YYYY');
      setInputValue(singleVal);
      setIsOpen(false);
      if (onChange) onChange({ target: { name, value: singleVal } });
    }
  };

  return {
    containerRef,
    isFocused,
    setIsFocused,
    isOpen,
    setIsOpen,
    currentDate,
    setCurrentDate,
    startDate,
    endDate,
    inputValue,
    handleInputChange,
    handleDayClick,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/SelectDate/hooks/useSelectDate.js